<template>
  <div
    id="jqImg4"
    class="domePrint colorBack"
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
    :class="{ isChildBackground: inquiryInfo.IsChild }"
  >
    <div class="title">
      <div class="bianju">
        <div class="hospitalOpen colorBack">{{ inquiryInfo.TitleName }}</div>
      </div>
    </div>
    <div class="payOff colorBack">
      <div class="payOff_item" style="align-items:center;">
        <div class="margin-left titleColor margin-right6">费用：</div>
        <div class="flex1 m-r">
          <span class="icon iconfont icon_kou">&#xe65f;</span>
          <label class="titleColor ">公费</label>
          <span class="icon iconfont icon_kou">&#xe65f;</span>
          <label class="titleColor">自费</label>
          <span class="icon iconfont icon_kou">&#xe65f;</span>
          <label class="titleColor">医保</label>
          <br />
          <span class="icon iconfont icon_kou">&#xe65f;</span>
          <label class="titleColor">其他</label>
        </div>
      </div>
      <div class="payOff_item">
        <div class="m-r titleColor">
          {{ "处方编号：" + inquiryInfo.OutOrderId }}
        </div>
      </div>
    </div>
    <div class="posionInfo posionInfo_space">
      <div class="flex1 margin-left mtb colorBack">
        <div class=" flex1 colorBack">
          <div class="lableStr colorBack">姓名：</div>
          <div class="name colorBack f14">{{ inquiryInfo.Name }}</div>
        </div>
        <div class="flex1 m-r lableStr colorBack">
          <span class="colorBack">性别：</span>
          <span class="colorBack f14">{{
            inquiryInfo.Sex == 1 ? "男" : "女"
          }}</span>
        </div>
        <div class="flex1 m-r">
          <div class="lableStr colorBack">年龄：</div>
          <div class="age colorBack f14" style="white-space: nowrap">
            {{ inquiryInfo.AgeStr }}
          </div>
        </div>
        <div class="flex1">
          <div class="lableStr colorBack">体重：</div>
          <div class="age colorBack f14" style="white-space: nowrap">
            <span v-if="inquiryInfo.Month<=168" style="width: 50px;display: inline-block;">{{
              inquiryInfo.Weight.replace("kg", "") == 0
                ? ""
                : inquiryInfo.Weight.replace("kg", "")
            }}</span>
            kg
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">科别：</div>
            <div class="age colorBack  f14">{{ inquiryInfo.Department }}</div>
          </div>
        </div>
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">开具日期：</div>
            <div class="age colorBack  f14">{{ inquiryInfo.ExpiredTime }}</div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="lableStr colorBack">临床诊断：</div>
        <div class="name colorBack f14">{{ inquiryInfo.Diseases }}</div>
      </div>
    </div>
    <div class="drugInfo">
      <div class="margin-left">
        <div class="rp">Rp</div>
        <!-- 西药 -->
        <div v-if="!_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i">
            <div class="flex1">
              <div class="colorBack f12">
                <span class="f12">{{ item.Name }}</span>
                <span style="margin-left: 50px;" class="f12">{{
                  item.Specs
                }}</span>
              </div>
              <div class="colorBack f12" style="padding-right: 20px;">{{ item.Count }}{{ item.Unit }}</div>
            </div>
            <div class="colorBack f12">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
          </div>
        </div>
        <!-- 中药 -->
        <div v-if="_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i">
            <!-- <div class="flex_d"> -->
            <!-- <div class="colorBack">{{ item.Name }}</div>
                  <div class="colorBack">{{ item.Specs }}</div>
                  <div class="colorBack">{{ item.Count }}{{ item.Unit }}</div> -->
            <div class="colorBack f12" v-if="chackB(item)">{{ item.Name }}</div>
            <div class="chinese-medicine-grid">
              <div
                class="colorBack medicine-item f12"
                v-for="uitem in inquiryInfo.useCNDrugsList"
                :key="uitem.Id"
              >
                {{ uitem.Name }}
                <span
                  class="colorBack lo_decoction_tip "
                  :class="{ lo_p_decoction_tip: uitem.Decoction }"
                  >{{ uitem.Decoction || "" }}</span
                >
                {{ uitem.Count }}{{ uitem.Unit }}
              </div>
            </div>
            <!-- </div> -->
            <div class="colorBack f12">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
            <div class="colorBack f12">
              总量：{{ item.Count }}{{ item.Unit }}
            </div>
          </div>
        </div>
      </div>
      <div class="blank margin-left">
        <span class="colorBack f12">以下空白</span>
        <div class="oksize colorBack" v-if="inquiryInfo.AuditStampUrl">
          <img :src="inquiryInfo.AuditStampUrl" alt width="134" />
        </div>
      </div>
    </div>
    <div class="posionInfo " style="margin-top: 50px;padding-left: 15px;">
      <div class="flex1 mtb">
        <div class="flex2 flex_all">
          <div class="lableStr colorBack">医师：</div>
          <div class="name colorBack phr_name">
            <span class="f14" style="padding-right: 20px;">{{
              inquiryInfo.DoctorName
            }}</span>
            <img
              v-if="
                inquiryInfo.DoctorNameUrl &&
                  inquiryInfo.DoctorNameUrl.length > 0
              "
              :src="inquiryInfo.DoctorNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <div class="flex2 flex_all">
          <div class="lableStr colorBack">审核药师：</div>
          <div class="name phr_name">
            <span class="f14" style="padding-right: 20px;">{{
              inquiryInfo.PharmacistName
            }}</span>
            <img
              v-if="
                inquiryInfo.PharAuditNameUrl &&
                  inquiryInfo.PharAuditNameUrl.length > 0
              "
              :src="inquiryInfo.PharAuditNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
      </div>

      <div class="flex1 mtb">
        <div class="flex1 flex_all">
          <div class="lableStr colorBack">核发、发药药师：</div>
          <div class="name phr_name ">
            <img
              v-if="
                inquiryInfo.PharReviewNameUrl &&
                  inquiryInfo.PharReviewNameUrl.length > 0
              "
              :src="inquiryInfo.PharReviewNameUrl"
              width="80"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>

        <div class="flex2 flex_all">
          <div class="lableStr colorBack">调配药师/士：</div>
          <div class="name phr_name">
            <img
              v-if="
                inquiryInfo.PharDispensingNameUrl &&
                  inquiryInfo.PharDispensingNameUrl.length > 0
              "
              :src="inquiryInfo.PharDispensingNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
      </div>
    </div>
    <div class="colorBack phar_tip" style="padding-left: 15px;">医师开具处方当日有效(医师注明除外)</div>
    <div class="explain">
      <img
        v-if="inquiryInfo.StampType == 1"
        class="imgStr"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
      <img
        v-if="inquiryInfo.StampType == 2"
        class="imgStr_yuang"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
    </div>
    <div class="flex5 colorBack phar_tip" style="padding-left: 15px;" >
      <div>本处方为患者在</div>
      <div class="com_name f14">{{ inquiryInfo.CompanyName }}使用</div>
    </div>
    <div v-if="inquiryInfo.Notice" class="phar_tip" style="padding-left: 15px;">
      <span class="colorBack ">备注：{{ inquiryInfo.Notice}}</span>
    </div>
  </div>
</template>

<script>
import "@/utils/jquery.jqprint-0.3";
export default {
  components: {},
  props: {
    inquiryInfo: {
      type: [Object, Array],
      default: {},
    },
    _deptCode: {
      type: [String, Boolean],
      default: false,
    },
    appMobilePhone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    chackB(item){
      if(!item.UpcCode) return false
      return item.UpcCode.charAt(0) != 'B';
    },
  },
};
</script>

<style lang="scss" scoped>
.domePrint {
  text-align: left;
  background: #ffffff;
  padding: 20px;
  width: 700px;
  height: 1000px;
  margin: auto;
  .rp {
    font-size: 30px;
    color: black;
  }
  .visibility {
    visibility: hidden;
  }
  .icon_kou {
    font-size: 10px;
    margin-left: 5px;
  }
  .titleColor {
    color: black;
    font-size: 14px;
  }
  .colorBack {
    color: black;
    font-size: 14px;
  }
  .flex_d {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }
  .flex_d_item {
    flex: 0 0 33%;
  }
  .margin-left {
    margin-left: 20px;
    margin-right: 20px;
  }
  .margin-right6 {
    margin-right: 6px;
  }
  .data {
    padding: 8px 0px;
    .heng {
      border-bottom: 1px solid black;
    }
  }
  .widthStr280 {
    width: 280px;
  }
  .widthStr340 {
    width: 340px;
  }
  .widthStr {
    width: 300px;
  }
  .widthStr1 {
    width: 322px;
  }
  .widthStr2 {
    width: 280px;
  }
  .widthStr3 {
    width: 200px;
  }
  .widthStr4 {
    width: 250px;
  }
  .m-r {
    margin-right: 10px;
  }
  .explain {
    padding-bottom: 5px;
    font-size: 15px;
    padding-left: 5px;
    position: relative;
    .imgStr_yuang {
      max-width: 150px;
      position: absolute;
      top: -273px;
      right: 209px;
    }

    .imgStr {
      max-width: 250px;
      position: absolute;
      top: -80px;
      right: 0px;
    }
  }
  .drugInfo {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
    position: relative;
    min-height: 430px;
    .blank {
      border-top: 1px solid black;
      width: 60%;
      margin-top: 15px;
      padding: 5px;
      text-align: center;
      margin-bottom: 100px;
      .oksize {
        position: absolute;
        right: 100px;
        bottom: 20px;
        .okName {
          position: absolute;
          top: 15px;
          left: 50px;
          color: red;
          font-weight: bold;
        }
        .okData {
          position: absolute;
          bottom: 16px;
          left: 30px;
          color: red;
          font-weight: bold;
        }
      }
    }
  }
  .posionInfo_space {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
  }
  .posionInfo {
    .mtb {
      padding-top: 10px;
    }
    .lableStr {
      width: auto;
      white-space: nowrap;
    }

    .name {
      width: 100%;
      //   border-bottom: 1px solid black;
    }
    .tonSize {
      width: 100%;
    }
    .age {
      width: 100%;
      //   border-bottom: 1px solid black;
    }

    .lastTonSize {
      width: 200px;
    }
  }
  .payOff {
    display: flex;
    justify-content: space-between;
    justify-items: start;
    align-items: flex-end;
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }
  .payOff_item {
    display: flex;
    justify-items: start;
    align-items: flex-end;

    // border-bottom: 1px solid black;
    // padding-bottom: 5px;
  }
  .title {
    margin: 30px 0 10px 0;
    text-align: center;
    position: relative;
  }

  .bianju {
    // line-height: 80px;
  }
  .hospitalName {
    font-size: 23px;
    font-weight: bold;
  }
  .hospitalOpen {
    font-size: 29px;
    font-weight: 450px;
  }
}
// .isChildBackground {
//   // background: #efffdd !important;
//   background: #c9fee0;
// }

.flex_all {
  flex: 1;
  align-items: flex-end;
}
.phr_name {
  width: 80%;
  border-bottom: 1px solid #e3e1e1;
  font-size: 14px;
  margin-right: 20px;
}
.phar_tip {
  margin-top: 15px;
}
.f14 {
  //   font-size: 14px !important;
}
.f12 {
  font-size: 12px !important;
}
.com_name {
  border-bottom: 1px solid black;
  // flex: 1;
  padding-left: 10px;
  width: 80%;

}

.flex5 {
  display: flex;
}

.lo_decoction_tip {
  display: inline-block;
  white-space: nowrap;
  font-size: 8px !important;
  height: 26px;
  vertical-align: bottom;
}
.lo_p_decoction_tip {
//   padding: 0 4px;
}
.chinese-medicine-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
//   gap: 10px;
}

.medicine-item {
  height: 30px;
  //   padding: 0 5px;
}
</style>
